<template>
    <rkm-modal
        extra-large
        ref="RkmModal"
        title="Solicitação"
    >
        <List
            v-if="mode === 'list'"
            @create="create"
            is-modal
        />

        <Form
            v-else
            :paciente-id="id"
            @saveExit="handleSaveExit"
            ref="Form"
        />

        <template v-slot:footer>
            <rkm-button @click="close">
                <template v-if="mode === 'list'">
                    Fechar
                </template>

                <template v-else>
                    Cancelar
                </template>
            </rkm-button>

            <rkm-button
                v-if="mode === 'form'"
                @click="$refs.Form.saveExit()"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from '@/components/regulacao/solicitacao/Form'
import List from '@/components/regulacao/solicitacao/List'

export default {
    components: {
        Form,
        List,
    },
    data: () => ({
        id: null,
        mode: 'list',
    }),
    methods: {
        open() {
            this.$refs.RkmModal.show()
        },
        create(id) {
            this.id = id

            this.$nextTick().then(() => this.mode = 'form')
        },
        handleSaveExit() {
            this.id = null
            this.mode = 'list'
            this.$refs.RkmModal.hide()
        },
        close() {
            if (this.mode === 'list') {
                this.id = null
                this.$refs.RkmModal.hide()
            } else {
                this.id = null
                this.mode = 'list'
            }
        },
    },
}
</script>